import { BaseComponent } from './basecomponent';

/**
 * Repr�sente la page de base d'un composant "connect�"
 * @extends BaseComponent
 */
export class IPageComponent extends BaseComponent {

    /**
     * Constructeur
     */
    constructor() { super(); }
}
